var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZa = function SvgZa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.515 20.485c-4.687-4.686-4.687-12.284 0-16.97L10.435 12l-6.92 8.485Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M10.435 12 1.592 6.024c-.274.477-.516.974-.724 1.49L5.345 12 .868 16.488c.208.514.45 1.011.723 1.488L10.435 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M23.898 10.435H10.434l-6.92-6.92a12.047 12.047 0 0 0-1.923 2.509L7.556 12 1.59 17.975c.53.92 1.177 1.764 1.923 2.51l6.92-6.92h13.464a12.118 12.118 0 0 0 0-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M4.693 21.518A11.947 11.947 0 0 0 12 23.998c5.545 0 10.21-3.76 11.587-8.869H11.082l-6.389 6.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M23.586 8.869c-1.377-5.11-6.042-8.87-11.587-8.87-2.75 0-5.282.926-7.306 2.48l6.39 6.39h12.503Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgZa;